// Report-param grammar for the info-view histogram, ported from the coffee shell
// (importReportParams / updateReportParams / export).
//
// One value is stored: how many bins the histogram is drawn with. The chart opens on the number
// the report author fixed, or on the first one the question offers, and only a number the
// researcher picked themselves is written back.

export const resolveDefaultPeriod = ({ format, bars = [] } = {}) =>
  undefined === format?.bars ? bars[0] : String(format.bars)

// A stored bin count the question no longer offers would draw nothing, so it gives way to the first one
// offered. While the question offers none yet there is nothing to check it against, and it stands.
const resolveStoredPeriod = (period, bars = []) => {
  if (null == period || '' === period) return null
  if (!bars.length) return period

  return bars.find(bar => String(bar) === String(period)) ?? bars[0]
}

export const resolveReportParams = ({ params = {}, format, bars } = {}) => ({
  period: resolveStoredPeriod(params.hg?.period, bars) || resolveDefaultPeriod({ format, bars })
})

export const calcReportParamsSection = (state = {}, { format, bars } = {}) => ({
  hg: state.period === resolveDefaultPeriod({ format, bars }) ? null : { period: state.period }
})

// The state the pptx / summary exporters read off the chart.
export const calcExportData = (state = {}) => ({ period: state.period })
